/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditpackconfirmfailed3Inputs */

const en_creditpackconfirmfailed3 = /** @type {(inputs: Creditpackconfirmfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn't confirm your purchase just now. Contact us if the credits don't arrive within a few minutes.`)
};

const de_creditpackconfirmfailed3 = /** @type {(inputs: Creditpackconfirmfailed3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Kauf ließ sich gerade nicht bestätigen. Schreib uns, falls die Credits nicht in ein paar Minuten da sind.`)
};

/**
* | output |
* | --- |
* | "We couldn't confirm your purchase just now. Contact us if the credits don't arrive within a few minutes." |
*
* @param {Creditpackconfirmfailed3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditpackconfirmfailed3 = /** @type {((inputs?: Creditpackconfirmfailed3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpackconfirmfailed3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditpackconfirmfailed3(inputs)
	return de_creditpackconfirmfailed3(inputs)
});
export { creditpackconfirmfailed3 as "creditPackConfirmFailed" }